import { Span } from 'themes/jumbo/@jumbo/shared';
import {
  Avatar,
  Chip,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import { DemoType } from './types';
import { getCachedData } from "api/Cache";
import { useHistory } from 'react-router-dom';

const DemoItem = ({ item }: {item:DemoType}) => {
  const { ID:demoID, name:demoName = 'Unknown Project', image = '', thumbnail = '', file_date:creationDate = '' } = item;
  const data: any = getCachedData();
  var views = data["views"];
  const projectViews = Object.values(views)
    .filter((view: any) => view.project === demoID)
      .sort((a:any, b:any) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
  const viewsImages: any[] = projectViews.filter((view: any) => view.has_thumbnail === "1" && view.thumb);
  let projectImage;

  if (viewsImages.length && !(image || thumbnail)) {
    projectImage = viewsImages[0].thumb;
  }
  const history = useHistory();
  const handleClick = (e: any) => {
      history.push(`/catalog/${demoID}`);
  };

  return (
    <ListItemButton
      component={'li'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        maxHeight: '125px',
        flex: '1 1 19%'
      }}
      onClick={handleClick}
      className='demoItemCard'
    >
      <ListItemAvatar sx={{ 
        minWidth: '100%', 
        overflow: 'hidden', 
        borderRadius: 2 
      }}>
        <img
          alt={demoName}
          src={projectImage}
          width={"100%"}
          height={75}
          style={{ verticalAlign: 'middle' }}
          className='demoImage'
        />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography variant={'h6'} mb={0.5} className='listItemTitle'>
            {demoName}
          </Typography>
        }
      />
    </ListItemButton>
  );
};

export { DemoItem };
